import { useQuery } from '@tanstack/react-query';

import { PluginEntitiesResponse } from '../../../../types/plugins';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { runDeleteGuarantorForm } from '../../requests/runDeleteGuarantorForm';

export const useDeleteGuarantorForm = (
  applicationUuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructPost } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    | NonPaginatedResponse<PluginEntitiesResponse<'individuals' | 'businesses'>>
    | undefined
  >({
    queryKey: [PLUGIN_BASE_PATH, 'delete-guarantor-form', applicationUuid],
    queryFn: () =>
      runDeleteGuarantorForm(constructPost, {
        params: { uuid: applicationUuid },
      }),
    enabled: !!applicationUuid,
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'formData'), ...rest };
};
